/* eslint-disable */
import cf7Helpers from '../../../src/js/shared/cf7Helpers';

'use strict';

const $ = jQuery.noConflict();

$(function () {
    const eliteAccess = {
        init: function () {
            this.injectDescriptions();
            this.initCheckboxSync();
            this.bindSubmitState();
            cf7Helpers.afterFormSubmit('.js-elite-access-holder', 'form-is-sent', 6000);
        },

        bindSubmitState: function () {
            const $holder = $('.js-elite-access-holder');

            // disable the submit button right away so it can't be clicked again
            // while the CF7 ajax request is in flight
            $holder.on('submit', 'form.wpcf7-form', function () {
                $(this).find('input[type="submit"]').prop('disabled', true);
            });

            // wpcf7submit fires once the ajax response comes back, whether the
            // submission succeeded or failed, so re-enabling here covers both
            $holder.on('wpcf7submit', function (event) {
                $(event.target).find('input[type="submit"]').prop('disabled', false);
            });
        },

        injectDescriptions: function () {
            $('.js-elite-access-form input[name="access_level[]"]').each(function () {
                const $input = $(this);
                const description = $input.data('description');
                const $label = $input.closest('label');

                if (description && !$label.find('.elite-access__checkbox-desc').length) {
                    $label.append(`<span class="elite-access__checkbox-desc">${description}</span>`);
                }
            });
        },

        initCheckboxSync: function () {
            const $realBoxes = $('.js-elite-access-form input[name="access_level[]"]');
            const $allBox = $('.js-elite-access-form .js-elite-access-all');

            if (!$realBoxes.length || !$allBox.length) {
                return;
            }

            let isSyncing = false;

            $allBox.on('change', function () {
                if (isSyncing) {
                    return;
                }
                isSyncing = true;
                $realBoxes.prop('checked', $allBox.is(':checked')).trigger('change');
                isSyncing = false;
            });

            $realBoxes.on('change', function () {
                if (isSyncing) {
                    return;
                }
                isSyncing = true;

                const allChecked = $realBoxes.length === $realBoxes.filter(':checked').length;
                const wasAllChecked = $allBox.is(':checked');

                if (allChecked && !wasAllChecked) {
                    $allBox.prop('checked', true);
                } else if (!allChecked && wasAllChecked) {
                    $allBox.prop('checked', false);
                }

                isSyncing = false;
            });
        }
    };

    eliteAccess.init();
});
